import { apiFetch } from "@/lib/api";
import type { MrpIncomingRow, MrpInventoryRow, MrpInventorySublocationRow, MrpSkuHoverHintFields } from "@/lib/mrp";

export const KITTING_PICK_DATA_QUERY_STALE_MS = 5 * 60 * 1000;

export type KittingPickDataApiResponse = {
  incoming_rows: MrpIncomingRow[];
  inventory_rows: MrpInventoryRow[];
  sublocation_rows: MrpInventorySublocationRow[];
  sku_hover_hints: Record<string, MrpSkuHoverHintFields>;
};

export function kittingPickDataQueryKey(slotIds: readonly string[]): readonly string[] {
  const normalized = slotIds.map((slotId) => slotId.trim()).filter((slotId) => slotId.length > 0);
  return ["manufacturing", "kitting", "pick-data", normalized.join(",")];
}

export function fetchKittingPickData(slotIds: readonly string[]): Promise<KittingPickDataApiResponse> {
  const normalized = slotIds.map((slotId) => slotId.trim()).filter((slotId) => slotId.length > 0);
  return apiFetch<KittingPickDataApiResponse>("/api/manufacturing/kitting/pick-data", {
    query: { slots: normalized.join(",") },
  });
}
